import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { closeModal, setModalType } from "../../redux/slices/uiSlice";
import ModalWrapper from "./ModalWrapper";
import ResetImage from "../../assets/images/auth/reset-img.png";
import { useTranslation } from "react-i18next";


const VerifyAccountModal: React.FC = ({ email }: { email?: string | null }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleBack = () => {
    dispatch(setModalType("forgotPassword"));
  };

  const handleResend = () => {
    dispatch(setModalType("resetPassword"));
  };

  if (!email) {
    return null;
  }

  return (
    <ModalWrapper onClose={handleClose} showBackButton onBack={handleBack}>
      {/* Header */}
      <div className="text-center lg:mb-[0.6vw] mb-3">
        <h1 className="lg:text-[1.9vw]/[2.2vw] text-2xl/6 font-semibold text-primary-orange lg:mb-[0.3vw] mb-2">
          {t("verifyAccount.verifyEmail")}
        </h1>
        <p className="lg:text-[1.1vw]/[1.4vw] text-base/tight text-black-800 font-bold">
          {t("verifyAccount.checkVerificationLink")}
          <span className="text-primary-orange"> {email}</span> {t("verifyAccount.toVerifyEmail")}
        </p>
      </div>

      {/* Image */}
      <div className="lg:mb-[0.6vw] mb-3">
        <img
          src={ResetImage}
          alt="reset-img"
          className="mx-auto 2xl:w-[10.417vw] md:w-[130px] w-25 2xl:h-[10.417vw] md:h-[130px] h-25 object-contain"
        />
      </div>

      {/* Resend Button */}
      {/* <button
        onClick={handleResend}
        className="w-full 2xl:rounded-[0.26vw] rounded-[5px] h-full flex
    skew-x-[-10deg]
    2xl:border-[0.104vw] border-[1.5px] lg:text-[1.1vw]/[1.4vw] md:text-lg/tight text-base/tight font-bold text-primary-yellow bg-primary-yellow border-black-300 transition-all duration-200 cursor-pointer text-center disabled:opacity-50 disabled:cursor-not-allowed 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706]"
      >
        <span className="2xl:pt-[0.7vw] pt-2.5 2xl:m-[0.208vw] m-1 !mt-0 2xl:py-[0.5vw] py-2 lg:px-[5%] px-4 2xl:rounded-[0.26vw] rounded-[5px] skew-x-[0deg] !border-t-0 2xl:border-[0.104vw] border-[1.5px] border-black-300 bg-[linear-gradient(180deg,#D76A4D_0%,#B35840_101.89%)] w-full h-full"><span className="skew-x-[10deg] block">{t("verifyAccount.continue")}</span></span>
      </button> */}

      <div className="text-center lg:mt-[1.1vw] mt-4">
        <span className="lg:text-[1.1vw]/[1.3vw] text-base/tight text-black-800 font-bold">
          {t("verifyAccount.didntGetLink")}
        </span>
        <button
          onClick={handleResend}
          className="lg:text-[1.1vw]/[1.3vw] text-base/tight font-semibold text-primary-orange hover:underline cursor-pointer ml-1"
        >
          {t("verifyAccount.resend")}
        </button>
      </div>
    </ModalWrapper>
  );
};

export default VerifyAccountModal;
